import { Fab, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { notNullOrEmpty } from '../../utils/common';
import { EmobilityPreviewStepProps } from './emobilityPreviewStep';

const useStyles = makeStyles({ name: 'EmobilityPreview' })(theme => ({
	root: {
		background: theme.palette.background.paper,
		border: '1px solid ' + theme.palette.divider,
		padding: 28,
		[theme.breakpoints.up('md')]: {
			padding: 40
		}
	},
	legend: {
		border: 'unset',
		width: 'unset',
		margin: 0,
		display: 'none',
		[theme.breakpoints.up('md')]: {
			display: 'block'
		}
	},
	title: {
		color: theme.palette.text.primary,
		'&.inner': {
			[theme.breakpoints.up('md')]: {
				display: 'none'
			}
		}
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 30
	},
	panelSteps: {
		display: 'flex',
		gap: 30,
		flexWrap: 'wrap',
		marginBottom: 20
	},
	stepWrapper: {
		minWidth: 230,
		flex: 1
	}
}));

export type EmobilityPreviewProps = {
	children: React.ReactElement<EmobilityPreviewStepProps>[];
	title?: string;
	labelButton: string;
	onOpenClick?: () => void;
	classes?: Partial<ReturnType<typeof useStyles>['classes']>
};

export const EmobilityPreview = (props: EmobilityPreviewProps) => {
	const { children, title, labelButton, onOpenClick } = props;
	const { classes: styles, cx } = useStyles(undefined, { props });

	return (
		<fieldset data-test='emobility-preview' className={styles.root}>

			{notNullOrEmpty(title) &&
				<React.Fragment>
					<legend className={styles.legend}>
						<Typography
							data-test='title-legend'
							variant='h2'
							className={styles.title}>
							{title}
						</Typography>
					</legend>
					<Typography
						data-test='title-inner'
						variant='h2'
						gutterBottom
						className={cx(styles.title, 'inner')}>
						{title}
					</Typography>
				</React.Fragment>}

			<div data-test='content' className={styles.content}>
				<div className={styles.panelSteps}>
					{children.map((child, index) =>
						<div
							data-test='step-wrapper'
							key={index}
							className={styles.stepWrapper}>
							{child}
						</div>)}
				</div>
				<Fab
					data-test='button-open-dialog'
					variant='extended' color='primary'
					onClick={onOpenClick}>
					{labelButton}
				</Fab>
			</div>

		</fieldset>
	);
};
